import { IGroupCreateEdit } from '@/src/context/hooks/useGroups';
import { AxiosInstance } from 'axios';

class GroupsPermissions {
  instance: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  getById(id: string) {
    return this.instance.get(`/admin/groups/${id}`);
  }

  get(search: string = '') {
    return this.instance.get(`/admin/groups?search=${search}`);
  }

  create(group: IGroupCreateEdit) {
    return this.instance.post('/admin/groups', group);
  }

  update(group: IGroupCreateEdit) {
    return this.instance.put(`/admin/groups/${group.id}`, group);
  }

  getAllPermissions() {
    return this.instance.get('/admin/permissions');
  }

}

const _GroupsPermissions = (instance: AxiosInstance) => new GroupsPermissions(instance);

export default _GroupsPermissions;
